/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as ShellIndexRouteImport } from './routes/_shell/index'
import { Route as ShellPriserRouteImport } from './routes/_shell/priser'
import { Route as ShellHistorikRouteImport } from './routes/_shell/historik'
import { Route as ShellAendringerRouteImport } from './routes/_shell/aendringer'
import { Route as ShellAccountRouteImport } from './routes/_shell/account'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPriserRoute = ShellPriserRouteImport.update({
  id: '/priser',
  path: '/priser',
  getParentRoute: () => ShellRoute,
} as any)
const ShellHistorikRoute = ShellHistorikRouteImport.update({
  id: '/historik',
  path: '/historik',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAendringerRoute = ShellAendringerRouteImport.update({
  id: '/aendringer',
  path: '/aendringer',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAccountRoute = ShellAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ShellRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/login': typeof LoginRoute
  '/account': typeof ShellAccountRoute
  '/aendringer': typeof ShellAendringerRoute
  '/historik': typeof ShellHistorikRoute
  '/priser': typeof ShellPriserRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/account': typeof ShellAccountRoute
  '/aendringer': typeof ShellAendringerRoute
  '/historik': typeof ShellHistorikRoute
  '/priser': typeof ShellPriserRoute
  '/': typeof ShellIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_shell': typeof ShellRouteWithChildren
  '/login': typeof LoginRoute
  '/_shell/account': typeof ShellAccountRoute
  '/_shell/aendringer': typeof ShellAendringerRoute
  '/_shell/historik': typeof ShellHistorikRoute
  '/_shell/priser': typeof ShellPriserRoute
  '/_shell/': typeof ShellIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account'
    | '/aendringer'
    | '/historik'
    | '/priser'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/account' | '/aendringer' | '/historik' | '/priser' | '/'
  id:
    | '__root__'
    | '/_shell'
    | '/login'
    | '/_shell/account'
    | '/_shell/aendringer'
    | '/_shell/historik'
    | '/_shell/priser'
    | '/_shell/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ShellRoute: typeof ShellRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/priser': {
      id: '/_shell/priser'
      path: '/priser'
      fullPath: '/priser'
      preLoaderRoute: typeof ShellPriserRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/historik': {
      id: '/_shell/historik'
      path: '/historik'
      fullPath: '/historik'
      preLoaderRoute: typeof ShellHistorikRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/aendringer': {
      id: '/_shell/aendringer'
      path: '/aendringer'
      fullPath: '/aendringer'
      preLoaderRoute: typeof ShellAendringerRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/account': {
      id: '/_shell/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof ShellAccountRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellAccountRoute: typeof ShellAccountRoute
  ShellAendringerRoute: typeof ShellAendringerRoute
  ShellHistorikRoute: typeof ShellHistorikRoute
  ShellPriserRoute: typeof ShellPriserRoute
  ShellIndexRoute: typeof ShellIndexRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellAccountRoute: ShellAccountRoute,
  ShellAendringerRoute: ShellAendringerRoute,
  ShellHistorikRoute: ShellHistorikRoute,
  ShellPriserRoute: ShellPriserRoute,
  ShellIndexRoute: ShellIndexRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ShellRoute: ShellRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
